// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip_tooltip__lOLnl {
  flex: none;
  background: var(--backgroundColor);
  color: var(--textColor);

  border-radius: 2px;
  padding: 6px 12px;

  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 15px;
  white-space: nowrap;

  pointer-events: none;
  z-index: 11;

  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);
}
.tooltip_tooltip__lOLnl[data-status='open'],
  .tooltip_tooltip__lOLnl[data-status='close'] {
    transition-duration: 0.2s;
    transition-property: opacity, margin;
  }
.tooltip_tooltip__lOLnl[data-status='initial'],
  .tooltip_tooltip__lOLnl[data-status='close'] {
    opacity: 0;
  }
.tooltip_tooltip__lOLnl[data-status='initial'][data-placement^='top'],
  .tooltip_tooltip__lOLnl[data-status='close'][data-placement^='top'] {
    margin-top: 34px;
  }
.tooltip_tooltip__lOLnl[data-status='initial'][data-placement^='bottom'],
  .tooltip_tooltip__lOLnl[data-status='close'][data-placement^='bottom'] {
    margin-top: -34px;
  }
.tooltip_tooltip__lOLnl[data-status='initial'][data-placement^='left'],
  .tooltip_tooltip__lOLnl[data-status='close'][data-placement^='left'] {
    margin-left: 34px;
  }
.tooltip_tooltip__lOLnl[data-status='initial'][data-placement^='right'],
  .tooltip_tooltip__lOLnl[data-status='close'][data-placement^='right'] {
    margin-left: -34px;
  }
`, "",{"version":3,"sources":["webpack://./src/components/tooltip/tooltip.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,kCAAkC;EAClC,uBAAuB;;EAEvB,kBAAkB;EAClB,iBAAiB;;EAEjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;;EAEnB,oBAAoB;EACpB,WAAW;;EAEX,+CAA+C;AA2BjD;AAzBE;;IAEE,yBAAyB;IACzB,oCAAoC;EACtC;AACA;;IAEE,UAAU;EACZ;AACA;;IAEE,gBAAgB;EAClB;AACA;;IAEE,iBAAiB;EACnB;AACA;;IAEE,iBAAiB;EACnB;AACA;;IAEE,kBAAkB;EACpB","sourcesContent":[".tooltip {\n  flex: none;\n  background: var(--backgroundColor);\n  color: var(--textColor);\n\n  border-radius: 2px;\n  padding: 6px 12px;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 15px;\n  white-space: nowrap;\n\n  pointer-events: none;\n  z-index: 11;\n\n  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);\n\n  &[data-status='open'],\n  &[data-status='close'] {\n    transition-duration: 0.2s;\n    transition-property: opacity, margin;\n  }\n  &[data-status='initial'],\n  &[data-status='close'] {\n    opacity: 0;\n  }\n  &[data-status='initial'][data-placement^='top'],\n  &[data-status='close'][data-placement^='top'] {\n    margin-top: 34px;\n  }\n  &[data-status='initial'][data-placement^='bottom'],\n  &[data-status='close'][data-placement^='bottom'] {\n    margin-top: -34px;\n  }\n  &[data-status='initial'][data-placement^='left'],\n  &[data-status='close'][data-placement^='left'] {\n    margin-left: 34px;\n  }\n  &[data-status='initial'][data-placement^='right'],\n  &[data-status='close'][data-placement^='right'] {\n    margin-left: -34px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `tooltip_tooltip__lOLnl`
};
export default ___CSS_LOADER_EXPORT___;
